import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialog, MatSort, PageEvent, Sort } from '@angular/material';
import { MapModalComponent } from '../map-modal/map-modal.component';
import { StorageService } from '../storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Duration, DateTime } from 'luxon';

import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { TimeService } from '../time.service';
import { ValidationService } from '../validation.service';
import { ShipmentDetailsComponent } from '../dashboardModals/shipment-details/shipment-details.component';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { ShareComponent } from '../share/share.component';
import { environment } from 'src/environments/environment';
import { Messages } from '../constants/messages';
import { AssignModalComponent } from '../dashboardModals/assign-modal/assign-modal.component';
import { ReAssignComponent } from '../re-assign/re-assign.component';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { SendEmailComponent } from '../share/send-email/send-email.component';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { CreateConsolidatedInvoiceComponent } from '../create-consolidated-invoice/create-consolidated-invoice.component';
import { AddShortageComponent } from '../add-shortage/add-shortage.component';
import { EpodsPrevComponent } from '../epods-prev/epods-prev.component';
import { debounceTime, distinctUntilChanged, mergeMap, map,startWith } from 'rxjs/operators';
import { merge } from 'rxjs';


@Component({
  selector: 'app-shipments-dashboard',
  templateUrl: './shipments-dashboard.component.html',
  styleUrls: ['./shipments-dashboard.component.scss']
})
export class ShipmentsDashboardComponent implements OnInit {
  @ViewChild("mwgRequest", { static: true }) mwgRequest: TemplateRef<any>;
  @ViewChild("odcRequest", { static: true }) odcRequest: TemplateRef<any>;
  @ViewChild("pullFreight", { static: true }) PullFreightDialg: TemplateRef<any>;
  @ViewChild("shiftshipments", { static: true }) shiftshipmentsDialog: TemplateRef<any>; changeInvoiceType
  @ViewChild("changeInvoiceType", { static: true }) changeInvoiceTypelDialog: TemplateRef<any>; 
  @ViewChild("missedEvent", { static: true }) missedEvent: TemplateRef<any>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('paginatorTop',{static:false}) topPaginator: MatPaginator;
  @ViewChild('paginatorBottom',{static:false}) bottomPaginator: MatPaginator;
  totalCount  = 0;

  isChecked: boolean = false;
  trackerUrl = environment.TRACKER_URL;
  showAdvanceSearch = false;
  URD;
  GTAtoGTA;
  tax_type;
  selectedPlantCode;
  selectedPlantStatus
  selectShip = false;
  showLoader = false;
  columnsToDisplay = ['sin', 'doNumbers', 'pickup_drop', 'date_time', 'vehicle_details', 'driver', 'distance', 'freight', 'material', 'action'];
  pickupPull: any;
  filterFrom = '';
  filterTo = '';
  fromDateString: any = '';
  toDateString: any = '';
  advanceSearch = false;
  maxDateFrom = new Date();
  maxDateTo = new Date();
  minDateTo = new Date();
  fromDate = '';
  toDate = '';
  fromDateTs;
  toDateTs;
  invoiceNo = '';
  lrNumber = '';
  sinNumber = '';
  organizations = [];
  shippers = [];
  disableShipper = false;
  disableOrganization = false;
  selectedOrganisation: any = {
    name: '',
    _id: ''
  };
  selectedShipper: any = {
    name: '',
    _id: ''
  };
  shippersArray = [];
  organizationArray = [];
  selectedMaterials = [];
  selectedPickups = [];
  selectedDeliveries = [];
  materialsArray: any = [];
  locationsArray: any = [];
  isCarrierShipment = false;
  shipmentsArray = [];
  totalShipments = 0;
  shipmentsFilter: any = {};
  shipments = new MatTableDataSource(this.shipmentsArray);
  shipmentDetails: any;
  markers: any = {
    sim: [],
    app: [],
    pickups: [],
    deliveries: []
  };
  message = new Messages();
  carrierId: Subscription;
  warningRef;
  acceptRef;
  delayedShipmentRef;
  mwgDialogRef: any;
  odcDialogRef: any;
  odcTextInput: any;
  files: any[] = [];
  odc_Do_number : string;
  odc_shipmentId : any;
  formData: FormData;
  odc_sin : any;
  pullFreightRef: any;
  shiftShipmentRef: any;
  shiftSin: any;
  shiftVehicleNo: any;
  shiftDonumbers: any;
  shiftshippersArr: any = [];
  changeInvoiceTypeRef: any;
  invoiceDisplayedColumns = [
    'sno',
    'invoice_type',  
    'invoice',
    // 'freightRate',
    'shippedQuantity',
    'shippedNoOfPieces',
    'actions'
  ];
  missedEventDialogRef: any;
  // missedEvents: any = ['PO','GI','TW','GW','PG','TC','IV','LR','EW','GO'];
  missed: any = [
    { name: 'Parking Out', value: 'PO'},
    { name: 'Gate In', value: 'GI'},
    { name: 'Tare Weight', value: 'TW'},
    { name: 'Gross Weight', value:'GW'} ,
    { name : "Post Goods",value:"PG" },
    { name :"Test Certificate",value:"TC"},
    { name : "Invoice",value:"IV"} ,
    { name :"Lorry Receipt",value:"LR"},
    { name :'E-way Bill' ,value:'EW'},
    { name :'Gate Out' ,value:'GO'}
  ];
  missedEvents: any;
  selectedMissedEvent: any;
  misssedEventDoNumber: any;
  missedEventShipmentId: any;
  invoiceDataSource: any = [];
  changeCT: any = '';
  changeInvoiceTypeShipmentId: any;
  invoiceType: any = [];
  selectedJsplPlantId: any;
  selectedJsplPlantName: any;
  shiftShipmentId: any;
  pickup: any;
  deliveryLocation: any;
  freightRate: any;
  selectedType:any = 'all'
  invoiceNumbers: any;
  fromPullFreight: any = false;
  selectedDestination: any;
  destination: any;
  SIN: any;
  vehicleNo: any;
  shipment: any;
  mwg = {
    sin: '',
    vehicle: '',
    material: '',
    doNumber: '',
    pickUp: '',
    drop: '',
    pickUpDate: '',
    loadedWeight: 0,
    shipper: '',
    vehicle_capacity: 0,
    mwga: 0,
    shipment: '',
    MWG: 0
  };
  showTracking = false;
  shipmentDelayData: any = {
    penalty: 0,
    reason: ''
  };
  re_assign_type = 'driver';
  searchTerm = '';
  vehicle_no1 = '';
  vehicle_no = '';
  mobile = '';
  isJSPL = false;
  helpData = [
    { head: 'Help', data: 'View all the Shipments.' },
    // { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  // helpImage = [
  //   { head: 'Image', source: 'assets/wp4151257.jpg'},
  //   { head: 'Image', source: 'assets/wp4151257.jpg'},
  // ];
  // helpVideo = [
  //   { head: 'Video', source: 'assets/mov_bbb.mp4'}
  // ];
  // helpTable = [
  //   { head: 'Table',
  //    tableArr: [
  //     {name: 'jhdsghf', address: 'tgbn', age: 'oibnm'},
  //     {name: 'yrujg', address: 'efgvb', age: '678'},
  //     {name: 'qwertyu', address: 'oijhb', age: '68'},
  //     {name: 'xcvbn', address: 'tghn', age: '09'},
  //   ],
  //   columnsToDisplay: ['name', 'address', 'age']
  // }
  // ];
  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('warning', { static: true }) warning: TemplateRef<any>;
  @ViewChild('acceptDialog', { static: true }) acceptDialog: TemplateRef<any>;
  @ViewChild('delayedShipment', { static: true }) delayedShipment: TemplateRef<any>;
  @ViewChild('plantCodeDialog', { static: true }) plantCodeDialog: TemplateRef<any>;
  selectedDONumbers: string[] = [];

  urlParams: any = {
    type: null
  };
  filter: any = '';
  symbol;
  type: string;
  dueIn: any;
  selectedShipments: any = [];
  plantMap: any;
  showStatus = false;
  statuses: any = [];
  invoices: any = [];
  filteredInvoices: any;
  plantCodeDialogRef: any;
  material_damage_percentage: any;
  material_missing_percentage: any;
  measure_unit: any;
  shipmentType: any;
  materials_array: any;
  do_no = '';
  DONumbers: any;
  statusArray = [
    { name: "Pending for Approval", value: "pending_for_approval" },
    { name: "Pending", value: "pending" },
    { name: "Approved", value: "approved" },
    { name: "Approved By Checker", value: "approved_by_checker" },
    { name: "Approved By Lead", value: "approved_by_lead" },
    { name: "Disapproved", value: "Disapproved" }
    
  ];
  selectedStatus:any;
  constructor(private storage: StorageService, private route: Router, private translation: TranslateService,
    private dialog: MatDialog, private http: HttpService, private snackbar: SnackbarService,
    private timeService: TimeService, private valid: ValidationService,
    private events: EventService, private actRoute: ActivatedRoute) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
    this.showTracking = environment.country == 'IN';
  }
  applyFilter(filterValue: string) {
    this.searchTerm = filterValue;
    this.shipments.filter = filterValue.trim().toLowerCase();
  }
  searchDo(filterValue: string) {
    this.do_no = filterValue;
    // this.showAdvanceSearch = true;
    if (this.do_no.length >= 7 || this.do_no.length === 0)
    this.getShipments();

  }
  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

  generateGetManyApiFitler(type) {
    switch (type) {
      case 'consent':
        return 'p_consent';
      case 'acceptance':
        return 'p_acceptance';
      case 'operations':
        return 'operations';
      case 'trackable':
        return 'trackable';
      case 'live_delayed':
        return 'l_delayed';
      case 'p_invoices':
        return 'p_invoices';
    }
  }

  ngOnInit() {
    this.shipments.paginator = this.paginator;
    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.symbol = currency[0].country.currency.symbol;
    this.getOrganisations();
    this.getShippers();
    this.getShipments();
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getShipments();
        this.getOrganisations();
        this.getShippers();

      }
    );
    this.actRoute.paramMap.subscribe(params => {
      this.urlParams.type = params.get('type');
      this.urlParams.shipmentType = this.urlParams.type.split('-')[0];
      this.urlParams.shipmentIds = this.urlParams.type.split('-')[1].split(',');
      if (this.urlParams.type) {
        this.filter = this.generateGetManyApiFitler(this.urlParams.type);
        if (this.urlParams.type.includes("due-")) {
          this.type = "due";
          this.dueIn = this.urlParams.type.split(/-(.*)/)[1];
          if (this.dueIn && this.dueIn === "Today") this.dueIn = 0;
          if (this.dueIn && this.dueIn === "Today - 1") this.dueIn = -1;
          if (this.dueIn && this.dueIn === "Today - 2") this.dueIn = -2;
          if (this.dueIn && this.dueIn === "Today - 3") this.dueIn = -3;
          if (this.dueIn && this.dueIn === "Today + 1") this.dueIn = +1;
          if (this.dueIn && this.dueIn === "Today + 2") this.dueIn = +2;
          if (this.dueIn && this.dueIn === "Today + 3") this.dueIn = +3;
        } else if (this.urlParams.shipmentType) {
          const shipmentIds = this.urlParams.shipmentIds;
          this.shipmentsFilter.shipmentIds = shipmentIds;
        }

        this.getShipments(this.shipmentsFilter);
      } else {
        this.getShipments(this.shipmentsFilter);
      }

    });
  }

  timeConvert(seconds) {
    const hours = Duration.fromObject({ second: seconds }).toFormat('hh:mm');
    return (hours.split(':')[0] + ' hrs ' + hours.split(':')[1] + ' mins');
  }
  clearSelection() {
    this.selectedShipments = [];
    this.selectedDONumbers = [];
  }

  changeTab(type) {
    this.selectedType = type
    if(type==='all') {
      this.shipmentsFilter.is_managed = false
    } else if(type==='managedBy'){
      this.shipmentsFilter.is_managed = true
    } else {
      // else case
    }
    this.getShipments(this.shipmentsFilter)
  }

  getShipments(filter: any = {}) {
    if (this.showAdvanceSearch) {
      (this.invoiceNo) ? filter.invoice_no = this.invoiceNo : '';
      (this.lrNumber) ? filter.lr_no = this.lrNumber : '';
      (this.sinNumber) ? filter.SIN = this.sinNumber : '';
      (this.fromDateTs) ? filter.from = this.fromDateTs : '';
      (this.toDateTs) ? filter.to = this.toDateTs : '';
      (this.organizationArray.length) ? filter.organizations = this.organizationArray : '';
      (this.shippersArray.length) ? filter.shippers = this.shippersArray : '';
      if (this.selectedStatus) filter.invoice_status = this.selectedStatus;
      (this.selectedMaterials && this.selectedMaterials.length) ? filter.materials = this.selectedMaterials.map(item => item._id) : '';
      (this.selectedPickups && this.selectedPickups.length) ? filter.pickups = this.selectedPickups.map(item => item._id) : '';
      (this.selectedDeliveries && this.selectedDeliveries.length) ? filter.deliveries = this.selectedDeliveries.map(item => item._id) : '';
      (this.mobile) ? filter.mobile = this.mobile.toString() : '';
      if (this.vehicle_no && this.vehicle_no.length > 7) {
        (this.vehicle_no) ? filter.vehicle_no = this.vehicle_no : null;
      }
    }
    if (this.do_no && this.do_no.length >= 7) {
      this.do_no ? filter.do_no = this.do_no : '';
    }
    this.showLoader = true;
    filter.limit = this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    if (this.filter) {
      filter.dashboard_filter = this.filter;
    }
    if (this.type === 'due') filter.dashboard_filter = this.type;
    if (this.dueIn || this.dueIn === 0) filter.due_in = this.dueIn;
    this.http.post('v2/shipment/many', filter).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.shipmentsArray = [];
          this.totalShipments = data.data.count;
          const result = data.data.shipments;
          result.forEach((element) => {
            const temp: any = {
              material: []
            };
            temp._id = element._id;
            temp.odc = element.odc;
            temp.sin = element.SIN;
            temp.from = element.pickups;
            temp.to = element.deliveries;
            temp.reqVehicleType = (element.vehicle_type && element.vehicle_type.name) ? element.vehicle_type.name : 'N/A';
            temp.reqVehicleType_id = (element.vehicle_type && element.vehicle_type._id) ? element.vehicle_type._id : 'N/A';
            temp.vehicleType = (element.driver) ? element.driver.vehicle_type.name
              : (element.assigned_driver) ? element.assigned_driver.vehicle_type.name : 'N/A';
            temp.vehicleNumber = (element.driver) ? element.driver.vehicle_no
              : (element.assigned_driver) ? element.assigned_driver.vehicle_no : 'N/A';
            temp.driverName = (element.driver) ? element.driver.name
              : (element.assigned_driver) ? element.assigned_driver.name : 'N/A';
            temp.driverMobile = (element.driver) ? element.driver.mobile
              : (element.assigned_driver) ? element.assigned_driver.mobile : 'N/A';
            temp.driver_id = (element.driver) ? element.driver._id
              : (element.assigned_driver) ? element.assigned_driver._id : 'N/A';
            temp.notAccepted = (!element.driver) ? true : false;
            temp.hasSmartPhone = (element.assigned_driver) ? element.assigned_driver.hasSmartPhone : false;
            temp.simTrackingCarrier = element.simTracking.carrier ? element.simTracking.carrier : '';
            temp.do_numbers = element.do_numbers;
            temp.shipper_parent_name = element.shipper.parent_name;
            temp.others = element.others ? element.others  : '';
            const mat = element.materials;
            mat.forEach(item => {
              temp.material.push(item);
            });
            console.log(element.shipper.parent_name);
            if(element.shipper.parent_name.toLowerCase().includes('jspl') || 
               element.shipper.parent_name.toLowerCase().includes('raigarh') || 
               element.shipper.parent_name.toLowerCase().includes('angul') ||
               element.shipper.parent_name.toLowerCase().includes('jsp')) {
              this.isJSPL = true;
            }
            if (element.latest_status === 'PNDG') {
              temp.status = 'Pending';
            } else if (element.latest_status === 'ALC') {
              temp.status = 'Allocated';
            } else if (element.latest_status === 'ACPT') {
              temp.status = 'Accepted';
            } else if (element.latest_status === 'ASN') {
              temp.status = 'Assigned';
            } else if (element.latest_status === 'ITNS') {
              temp.status = 'In Transit';
            } else if (element.latest_status === 'CPTD') {
              temp.status = 'Completed';
            } else if (element.latest_status === 'SP') {
              temp.status = 'Towards Pickup';
            } else if (element.latest_status === 'AP') {
              temp.status = 'At Pickup';
            } else if (element.latest_status === 'ALD') {
              temp.status = 'At Delivery';
            }
            else if (element.latest_status === 'ABTR') {
              temp.status = 'About to Reach';
            } else {
              temp.status = 'Cancelled';
            }
            temp.isCarrierShipment = (!element.shipper ? true : false);
            temp.inTransit = (temp.status == 'In Transit' || temp.status == 'Towards Pickup' || temp.status == 'At Pickup' || temp.status == 'At Delivery' || temp.status == 'About to Reach') ? true : false;
            temp.tripTracker = (element.trip_tracker && element.trip_tracker.methods && element.trip_tracker.methods.length) ? true : false;
            // temp.method = (element.trip_tracker && element.trip_tracker.methods && element.trip_tracker.methods.length) ? element.trip_tracker.methods : [];
            temp.method = (element.trip_tracker && element.trip_tracker.methods && element.trip_tracker.methods.length) ? element.trip_tracker.methods : [];
            // temp.show_consent = temp.method.indexOf('SIM') != -1 ? true: false;
            temp.trip_tracker = element.trip_tracker;
            temp.drop_num = element.deliveries.length;
            temp.scheduledDate = this.timeService.toShortDateTime(element.pickup_date);
            temp.actualDate = this.timeService.toShortDateTime(element.pickup_date);
            temp.unique_code = element.unique_code;
            temp.estimatedTime = (element.order) ? element.order.estimated ? this.timeConvert(element.order.estimated.duration) : 'N/A' : 'N/A';
            temp.remainingTime = 'N/A';
            temp.totalDistance = (element.order) ? temp.status !== 'Completed' ? (element.order.estimated ? (element.order.estimated.distance / 1000).toFixed(2) + ' kms' : 'N/A') : 'N/A' : 'N/A';
            temp.orderId = (element.order) ? element.order._id : ' ';
            // temp.remainingDistance = element.remaining ? (temp.status == 'In Transit' ? (element.remaining.distance / 1000).toFixed(2) + ' kms' : 'N/A') : 'N/A';
            temp.remainingDistance = (element.trip_tracker && element.trip_tracker.remaining_distance) ? (temp.inTransit ?
              (element.trip_tracker.remaining_distance / 1000).toFixed(0) + ' kms' : 'N/A') : 'N/A';
            temp.remainingTime = element.remaining ? (temp.inTransit ? (this.timeService.toDayMinSec(element.remaining.duration)) : 'N/A') : 'N/A';
            temp.coveredDistance = (element.trip_tracker && element.trip_tracker.travelled_distance) ? (temp.inTransit || temp.status == 'Completed' ?
              (element.trip_tracker.travelled_distance / 1000).toFixed(0) + ' kms' : 'N/A') : 'N/A';
            temp.currentLocation = 'N/A';
            temp.scheduledDeliveryDate = this.timeService.toShortDateTime(element.delivery_date);
            temp.actualDeliveryDate = this.timeService.toShortDateTime(element.delivery_date);
            temp.trackConsent = (element.simTracking) ? element.simTracking.isConsent : false;
            temp.whatsApp = (element.whatsapp) ? element.whatsapp : {};
            temp.disableGenerateInvoice = (element.carrier_invoices.length !== 0);
            // temp.simTrackingConsent = element.simTracking.isConsent;
            temp.showGreenConsent = element.simTracking.isConsent;
            temp.showRedConsent = !element.simTracking.isConsent && element.simTracking.isSubscribed;
            // temp.hideConsent = !element.simTracking.isConsent && !element.simTracking.isSubscribed;

            temp.delay_deduction = element.actual_delay_deduction ? element.actual_delay_deduction : 0;
            temp.material_damage_deduction = element.material_damage_deduction ? element.material_damage_deduction : 0;
            temp.material_missing_deduction = element.material_missing_deduction ? element.material_missing_deduction : 0;
            temp.carton_damage = element.carton_damage ? element.carton_damage : 0;
            temp.delay_penalty_waive_off = element.delay_penalty_waive_off || '';
            temp.freight = element.actual ? (element.actual.price ? element.actual.price : (element.estimated ? element.estimated.price || element.estimated.price_per_weight || element.estimated.price_per_pallet : 'N/A')) : 0;
            this.shipmentsArray.push(temp);
            temp.driverType = (element.assigned_driver && element.assigned_driver.driver_type) ? element.assigned_driver.driver_type : ''
            temp.gpsVehicle = false;
            temp.doNumbers = element.do_numbers && element.do_numbers.length && element.do_numbers.join(', ') || 'N/A';
            if (element.assigned_driver && element.assigned_driver.gps && element.assigned_driver.gps.provider && element.assigned_driver.gps.provider !== 'none') {
              temp.gpsVehicle = true;
            }
            if (element.assigned_driver && element.assigned_driver.vehicle && element.assigned_driver.vehicle.gps && element.assigned_driver.vehicle.gps.provider && element.assigned_driver.vehicle.gps.provider !== 'none') {
              temp.gpsVehicle = true;
            }
          });
          if (!this.shipments) {
            this.shipments = new MatTableDataSource(this.shipmentsArray);
            this.shipments.sort = this.sort;
            this.shipments.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('SHIPMENT_DASHBOARD.pagination_label');
          } else {
            this.shipments = new MatTableDataSource(this.shipmentsArray);
            this.paginator._intl.itemsPerPageLabel = this.translation.instant('SHIPMENT_DASHBOARD.pagination_label');
          }
          this.shipments.filterPredicate = (data: any, filter) => {
            const dataStr = JSON.stringify(data).toLowerCase();
            return dataStr.indexOf(filter) != -1;
          };
          if (this.searchTerm) {
            this.applyFilter(this.searchTerm);
          }

        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        this.paginator._intl.itemsPerPageLabel = this.translation.instant('SHIPMENT_DASHBOARD.pagination_label');
        if (err.error.statusCode === 401) {
          this.valid.logout();
        }
      }
    );
  }
  openGanttDashboard() {
    this.route.navigateByUrl('gantt');
  }

  pageNavigate(event) {
    this.shipmentsFilter.limit = event.pageSize;
    this.shipmentsFilter.skip = event.pageIndex * event.pageSize;
    this.getShipments(this.shipmentsFilter);
  }
  handlePageTop(e): void {
    const { pageSize, pageIndex } = e;
    this.bottomPaginator.pageSize = pageSize;
    this.bottomPaginator.pageIndex = pageIndex;
  }

  handlePageBottom(e): void {
    const { pageSize, pageIndex } = e;
    this.topPaginator.pageSize = pageSize;
    this.topPaginator.pageIndex = pageIndex;
    this.topPaginator.page.emit(e);
  }

  ngAfterViewInit(): void {
    merge(
      this.topPaginator.page,
      this.bottomPaginator.page
    ).pipe(
      startWith({}),
      debounceTime(300)
    ).subscribe(() => {
     
      this.getShipments(this.shipmentsFilter);
    });
  }
  openModal(row) {
    this.markers.sim = [];
    this.markers.app = [];
    this.markers.pickups = [];
    this.markers.deliveries = [];
    this.http.get('/v1/shipment/path?shipment=' + row._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          if (data.data.sim.length) {
            const simData = data.data.sim;
            this.markers.sim = simData;
          }
          if (data.data.app.length) {
            const appData = data.data.app;
            this.markers.app = appData;
          }
          row.from.forEach(element => {
            this.markers.pickups.push(element.location.geo_point.coordinates);
          });
          row.to.forEach(element => {
            this.markers.deliveries.push(element.location.geo_point.coordinates);
          });
          this.markers.geofence = data.data.geoFence;
          const dialogRef = this.dialog.open(MapModalComponent, {
            data: this.markers,

          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
          });
        }

      }
    );
  }



  openMapView() {
    this.route.navigateByUrl('shipment-map-view');
  }

  completeShipment(element,shipmentType) {
    const dialogData = {
      name: 'Complete Shipment',
      shipment_id: element._id,
      sin: element.sin,
      text: this.message.SHIPMENT_DETAILS.complete,
      url: 'shipment/complete',
      arrived_at: element.arrived_at,
      finished_at: element.finished_at,
      shipmentType: shipmentType
    };

    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.statusCode == 200 || result == 'yes') {
        this.getShipments(this.shipmentsFilter);
      }
    });
  }

  getAdditionalChargesFields() {
    this.http.get('constants').subscribe((response: any) => {
      if (response.statusCode == 200) {
        // this.additional_charges = response.data.invoice.additional_charges_enabled;
        this.URD = response.data.URD || false;
        this.tax_type = response.data.tax_type;
      }
    });
  }

  openShipmentDetails(row, tabI = 0) {
    this.showLoader = true;
    this.getAdditionalChargesFields();
    this.http.get('shipment/one?shipmentId=' + row._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.shipmentDetails = data.data;
          this.shipmentDetails.tabIndex = tabI;
          this.shipmentDetails.tax_type = this.tax_type;
          this.shipmentDetails.URD = this.URD;
          if (this.shipmentDetails.tabIndex == 6) {
            this.shipmentDetails.generateFreight = true;
          }
          this.shipmentDetails.purchase_order = (data.data.order && data.data.order.purchase_orders) || [];
          this.shipmentDetails.segmentation = (data.data.order && data.data.order.segmentation) || [];
          this.showLoader = false;
          const dialogRef = this.dialog.open(ShipmentDetailsComponent, {
            data: this.shipmentDetails,
            width: '1250px',
            maxWidth: '95vw !important'
          });

          dialogRef.afterClosed().subscribe(result => {
            this.shipmentDetails = {};
          });
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }



  share(element) {
    this.dialog.open(ShareComponent, {
      data: this.trackerUrl + element.unique_code
    });
  }

  sendEmail(element) {
    const dataToSend: any = {
      id: element._id,
      trackingUrl: this.trackerUrl + element.unique_code
    };
    this.dialog.open(SendEmailComponent, {
      data: dataToSend
    });
  }

  openAssignModal(data, label = 'Assign Driver') {

    console.log(data);
    var type = this.re_assign_type;
    const from = data.from[0].location.name + ' - ' + data.from[0].location.city;
    const to = data.to[data.to.length - 1].location.name + ' - ' + data.to[data.to.length - 1].location.city;
    data = {
      shipment_id: data._id,
      pickup: data.from[0],
      deliveries: data.to,
      order_id: data.orderId,
      vehicle_type: {
        _id: data.reqVehicleType_id != 'N/A' ? data.reqVehicleType_id : '',
        name: data.reqVehicleType
      },
      header: label,
      from,
      to,
      sin: data.sin,
      driver_id: data.driver_id,
      re_assign_type: type
    };
    const dialogRef = this.dialog.open(ReAssignComponent, {
      data: data,
      width: "1250px",
      maxWidth: "95vw !important",
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.getShipments();
        // this.openAssignSideModal(this.selectedOrderData);
      }
    });
  }
  accept(shipment) {
    if ((shipment.notAccepted) || shipment.hasSmartPhone) {
      if (shipment.driverName !== 'N/A') {

        const acceptData: any = {
          shipment_id: shipment._id,
          driver_id: shipment.driver_id
        };
        this.http.post('shipment/accept', acceptData).subscribe(
          (data: any) => {
            if (data.statusCode === 200) {
              this.snackbar.openSnackBar(this.message.SHIPMENT_DETAILS.success, '');
              this.getShipments();
            }
          },
          (err: any) => {
            this.snackbar.openSnackBar(err.error.message, '', 'err');
          }
        );
      }

    }
  }
  warningDialog(shipment) {
    this.re_assign_type = 'driver';
    if (shipment.driverName !== 'N/A') {
      this.warningRef = this.dialog.open(this.warning);
      this.warningRef.afterClosed().subscribe(
        (data: any) => {
          if (data) {
            this.openAssignModal(shipment, 'Re assign Driver');
          }
        }
      );
    } else {
      this.openAssignModal(shipment, 'Assign Driver');
    }
  }
  acceptDia(shipment) {
    this.acceptRef = this.dialog.open(this.acceptDialog);
    this.acceptRef.afterClosed().subscribe(
      (data: any) => {
        if (data) {
          this.accept(shipment);
        }
      }
    );
  }

  openShipmentDelayDialog(shipment) {
    this.shipmentDelayData.id = shipment._id;
    this.shipmentDelayData.penalty = shipment.actual_delay_deduction;
    this.shipmentDelayData.reason = shipment.delay_penalty_waive_off ? shipment.delay_penalty_waive_off.reason : '';
    this.shipmentDelayData.status = shipment.delay_penalty_waive_off ? shipment.delay_penalty_waive_off.status : '';
    this.shipmentDelayData.suggested_amount = shipment.delay_penalty_waive_off ? shipment.delay_penalty_waive_off.suggested_amount : 0;
    this.delayedShipmentRef = this.dialog.open(this.delayedShipment);
    this.delayedShipmentRef.afterClosed().subscribe(
      (data: any) => {
        this.shipmentDelayData.reason = '';
      }
    );
  }

  requestWaiveOff() {
    if (this.shipmentDelayData.reason) {
      let payload = {
        reason: this.shipmentDelayData.reason
      }
      this.showLoader = true;
      this.http.put('shipment/delay_penalty_waive_off/' + this.shipmentDelayData.id, payload).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.showLoader = false;
          this.shipmentDelayData.reason = '';
          this.getShipments();
          this.delayedShipmentRef.close();
        }
      },
        (err) => {
          this.showLoader = false;
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        });
    } else {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DASHBOARD.reason_waive_off'), '', 'err');
    }
  }


  openSubscribe(element) {
    const dialogData: any = {
      data: element
    };
    this.http.get('shipment/simTrack/status?id=' + element._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          dialogData.response = data.data;
          if (dialogData.response.carrier && dialogData.response.carrier === 'airtel') dialogData.response.message = 'Please provide your consent to track your location by your service provider, Please reply with Y to 5114040';
          if (dialogData.response.carrier && dialogData.response.carrier === 'vodafone') dialogData.response.message = 'Please provide your consent to track your location by your service provider, Please reply with Y to 55502 from Idea Number or send Y to 9167500066 from Vodafone number';
          if (dialogData.response.carrier && dialogData.response.carrier === 'jio') dialogData.response.message = 'Please provide your consent to track your location by your service provider, Please reply with Y to 5168524';
          this.dialog.open(SubscribeComponent, {
            data: dialogData
          });
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );

  }

  generateFreight(data) {

    data.generateFreight = true;
    this.openShipmentDetails(data, 6);
  }


  sortShipmentData(sort: Sort) {
    const dataToFilter = this.shipments.filteredData.slice();

    if (!sort.active || sort.direction === '') {
      this.shipments = new MatTableDataSource(this.shipmentsArray.slice());
      this.shipments.sort = this.sort;
      return;
    }

    const filtered = dataToFilter.sort((item1: any, item2: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'sin': return this.compare(item1.sin, item2.sin, isAsc);
        case 'pickup_drop': {
          let a: string;
          let b: string;
          (item1.from[0].location.name) ? a = item1.from[0].location.name : a = item1.from[0].location.city;
          (item2.from[0].location.name) ? b = item2.from[0].location.name : b = item2.from[0].location.city;
          return this.compare(a, b, isAsc);
        }
        case 'date_time': return this.timeService.compareDate(item1.scheduledDate, item2.scheduledDate, isAsc);
        case 'vehicle_details': return this.compare(item1.vehicleNumber, item2.vehicleNumber, isAsc);
        case 'driver': return this.compare(item1.driverName, item2.driverName, isAsc);
        case 'distance': return this.compare(item1.remainingDistance, item2.remainingDistance, isAsc);
        case 'material': return this.compare(item1.material[0].name, item2.material[0].name, isAsc);
        default: return 0;
      }
    });
    this.shipments = new MatTableDataSource(filtered);
    this.shipments.sort = this.sort;
    return;
  }

  compare(item1: number | string, item2: number | string, isAsc: boolean) {
    return (item1 < item2 ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setFromDate(value) {
    this.minDateTo = new Date(value);
    this.minDateTo.setDate(this.minDateTo.getDate() + 1);
    const t1: any = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');

    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy');
    this.fromDateTs = epoch.ts;
  }

  setToDate(value) {
    const t1: any = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy');
    this.toDateTs = epoch.ts;
  }

  selectOrganization(value) {
    this.organizationArray = [];
    this.selectedOrganisation.name = value.name;
    this.selectedOrganisation._id = value._id;
    this.organizationArray.push(this.selectedOrganisation._id);
  }

  selectShipper(value) {
    this.shippersArray = [];
    this.selectedShipper.name = value.name;
    this.selectedShipper._id = value._id;
    this.shippersArray.push(this.selectedShipper._id);
  }

  selectLocation(element, type = 'pick') {
    (type == 'pick') ? this.selectedPickups.push(element) : this.selectedDeliveries.push(element);
  }

  selectMaterial(element) {
    this.selectedMaterials.push(element);
  }

  toggle() {
    this.showAdvanceSearch = !this.showAdvanceSearch;
    (this.showAdvanceSearch) ? this.getFilters() : '';
  }

  getFilters() {
    const query: any = {};
    (this.selectedShipper._id) ? query.shipper = this.selectedShipper._id : '';
    (this.selectedOrganisation._id) ? query.organization = this.selectedOrganisation._id : '';
    this.showLoader = true;
    this.http.get('shipment/get_filter', query).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.showLoader = false;
          this.materialsArray = response.data.materials || [];
          this.locationsArray = response.data.locations || [];
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  getOrganisations() {
    this.http.get('carrier_pref').subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.organizations = [];
          if (data.data.organizations.length) {
            const org = data.data.organizations;
            org.forEach(element => {
              const temp: any = {};
              temp._id = element._id;
              temp.name = element.name;
              this.organizations.push(temp);
            });
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  getShippers() {
    this.showLoader = true;
    this.http.get('shippers').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          this.shippers = data.data;
        }
      },
      (err: any) => {
        console.log(err.error.message);
      }
    );
  }

  clear() {
    this.showAdvanceSearch = false;
    this.do_no = '';
    this.vehicle_no = '';
    this.mobile = '';
    this.fromDate = '';
    this.toDate = '';
    this.invoiceNo = '';
    this.lrNumber = '';
    this.sinNumber = '';
    this.selectedMaterials = [];
    this.selectedPickups = [];
    this.selectedShipper = '';
    this.selectedDeliveries = [];
    this.organizationArray = [];
    this.selectedStatus = '';
    this.selectedOrganisation = {
      name: '',
      _id: ''
    };
    this.toDateString = '';
    this.fromDateString = '';
    this.fromDateTs = '';
    this.toDateTs = '';
    this.materialsArray = JSON.parse(JSON.stringify(this.materialsArray));
    this.locationsArray = JSON.parse(JSON.stringify(this.locationsArray));
    this.disableShipper = false;
    this.disableOrganization = false;
    this.getShipments();
  }

  submitSearch() {
    if (!this.selectedOrganisation._id && !this.selectedShipper._id && !this.invoiceNo) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DASHBOARD.anyOne'), '', 'err');
      return false;
    } else {
      if (this.materialsArray.length || this.locationsArray.length) {
        this.searchFilter();
        this.vehicleMobileSearch();
      } else {
        this.getFilters();
      }
    }

  }

  searchFilter() {
    if ((!this.valid.isEmpty(this.fromDateTs) || !this.valid.isEmpty(this.toDateTs)) || !this.valid.isEmpty(this.invoiceNo) ||
      !this.valid.isEmpty(this.lrNumber) || !this.valid.isEmpty(this.sinNumber) || this.selectedMaterials.length || this.selectedPickups.length ||
      this.selectedDeliveries.length) {
      this.advanceSearch = true;
      this.getShipments(this.shipmentsFilter);

    } else if (!this.vehicle_no && this.vehicle_no.length == 0 && !this.mobile) {
      this.getShipments();
    }
    else {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.SHIPMENT_DASHBOARD.oneValue'), '', 'err');
    }
  }
  vehicleMobileSearch() {
    // console.log("vehicle mobile search called", this.vehicle_no, this.vehicle_no.match(/\d{4}\d/g))
    if (this.vehicle_no && this.vehicle_no.length > 8) {
      this.advanceSearch = true;
      this.shipmentsFilter.vehicle_no = this.vehicle_no;
      (this.shipmentsFilter.v_no) ? delete this.shipmentsFilter.v_no : '';
      this.getShipments(this.shipmentsFilter);
    }else  if (this.vehicle_no && this.vehicle_no.length ==4 && this.vehicle_no.match(/\d{4}/g) ) {
      // console.log("vehicle no", this.vehicle_no, this.shipmentsFilter);
      this.advanceSearch = true;
      (this.shipmentsFilter.vehicle_no) ? delete this.shipmentsFilter.vehicle_no : '';
      this.shipmentsFilter.v_no = this.vehicle_no.match(/\d{4}/g)[0];
      this.getShipments(this.shipmentsFilter);
    } else if (this.mobile && this.mobile.toString().length > 9) {
      this.advanceSearch = true;
      this.searchTerm = this.mobile;
      this.shipments.filter = this.searchTerm.trim().toLowerCase();
    } else if (!this.vehicle_no && this.vehicle_no.length == 0 && !this.mobile) {
      this.getShipments();
    }
  }
  stopProp($event) {
    $event.preventDefault(); $event.stopPropagation();
  }
  createInvoice() {
    this.dialog.open(CreateConsolidatedInvoiceComponent);
  }

  toggleRowSelection(row: any) {
    const rowIndex = this.selectedDONumbers.indexOf(row.doNumbers);
    if (rowIndex === -1) {
      this.selectedDONumbers.push(row.doNumbers);
    } else {
      this.selectedDONumbers.splice(rowIndex, 1);
    }
  }

  selectShipments(row) {
    this.shipmentDetails = undefined;
    if (this.selectedShipments.includes(row._id)) {
      this.selectedShipments.splice(this.selectedShipments.indexOf(row._id), 1);
    } else this.selectedShipments.push(row._id); 
    this.toggleRowSelection(row); 
  }

  getSelectedDONumbers(): string {
    return this.selectedDONumbers.join('\n');
  }

  getCarrierInvoiceDetails() {
    if (this.selectedShipments.length) {
      this.http.post('carrier_invoice/getCarrierInvoiceByInvoice', { shipmentIds: this.selectedShipments }, 1).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            const res = data.data;
            this.invoices = res.invoices;
            console.log("datta>>>>>", res);
            this.plantMap = this.findPlantMap(this.invoices);
            this.openPlantCodeDialog();
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    } else {
      this.snackbar.openSnackBar('Please select a shipment', '', 'err');
    }

  }

  findPlantMap(data) {
    data = data.filter(d => d.plant !== undefined);
    const res = [];
    const plantMap = {};

    // Iterate over each object in the array
    for (const obj of data) {
      const { plant, status } = obj;

      // Check if the plant exists in the plantMap
      if (plantMap[plant]) {
        // If the plant already exists, push the status to its array
        plantMap[plant].statuses.push(status);
      } else {
        // If the plant doesn't exist, create a new object and add it to the plantMap
        plantMap[plant] = {
          name: plant,
          statuses: [status],
        };
      }
    }

    // Push each plant object from the plantMap to the result array
    for (const plantObj of Object.values(plantMap)) {
      res.push(plantObj);
    }

    return res;
  }

  openPlantCodeDialog() {
    this.plantCodeDialogRef = this.dialog.open(this.plantCodeDialog)
  }

  selectPlantCode(event, ele) {
    if (event.source._selected) {
      this.selectedPlantCode = ele;
      this.showStatus = true
      this.statuses = this.selectedPlantCode.statuses;
    }
  }
  viewInvoices() {
    this.filteredInvoices = this.invoices.filter(
      inv => (inv.plant == this.selectedPlantCode && inv.status == this.selectedPlantStatus)
    );
    if (this.filteredInvoices.length) {
      this.plantCodeDialogRef.close();
      this.selectedPlantCode = {};
      this.selectedPlantStatus = '';
      this.showStatus = false;
      this.statuses = [];
      this.dialog.open(CreateConsolidatedInvoiceComponent, {
        data: {
          invoices: this.filteredInvoices,
          selectedShipmentId: this.selectedShipments
        }
      });
    }
  }

  addShortages(row, changeType: any) {
    const payload ={
      shipmentId : row._id,
    }
    this.http.get('v1/invoiceDetails' ,payload,1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          if (!changeType) {
            this.shipmentDetails = data.data;
            this.showLoader = false;
            const dialogRef = this.dialog.open(AddShortageComponent, {
              data: this.shipmentDetails,
            });
  
            dialogRef.afterClosed().subscribe(result => {
              this.shipmentDetails = {};
              this.getShipments(this.shipmentsFilter);
            });
          } else {
            const invoiceData = data.data;
            
            invoiceData.forEach((inv, i) => {
              const { commercial_invoices, _id } = inv;
              this.changeInvoiceTypeShipmentId = data.data.shipment_id;
              const temp = {
                _id,
                invoice: commercial_invoices[0].num,
                finalFreightRate: commercial_invoices[0].others.final_freight_rate || 0,
                invoiceType: commercial_invoices[0].others.invoice_type || 'CT',
                shippedQty: commercial_invoices[0].net_weight,
                shippedNop: commercial_invoices[0].nop,
              }
              this.invoiceDataSource.push(temp);
            });
            this.changeInvoiceTypeRef = this.dialog.open(this.changeInvoiceTypelDialog, {
              panelClass: 'icon-outside',
            });
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  openOdcDialg(element) {
    console.log("heyyy");
    console.log("element.odc as true & false >>>>>>>>",element.odc);
    if(element.odc) {
      console.log("coming");
      this.snackbar.openSnackBar('You cannot raise odc Request', '', 'err'); 
    } else {
      this.odc_Do_number = element.doNumbers;
      this.odc_shipmentId = element._id;
      this.odc_sin = element.sin;
      console.log("this.odc_sin>>>>>>>",this.odc_sin);
      this.odcDialogRef = this.dialog.open(this.odcRequest, {
        panelClass: 'icon-outside',
      });
    }
    
  }

  onFileDropped(files) {
    this.prepareFilesList(files);
  }
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }
  prepareFilesList(files: Array<any>) {
    if (files[0].type === 'application/pdf' && files.length === 1) {
      for (const item of files) {
        item.progress = 0;
        this.files.push(item);
      }
      // this.uploadFilesSimulator(0);
    } else this.snackbar.openSnackBar('Please upload only PDF file', '', 'err');
  }
  deleteFile(index: number) {
    this.files = [];
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  upload() {
    if (this.files.length) {
      this.formData = new FormData();
      this.odcTextInput;
        this.formData.append('odc_attachment', this.files[0], this.files[0].name);
        this.http.upload('v1/odcRequest/' + this.odc_shipmentId, this.formData, 1).subscribe(
          (data: any) => {
            this.showLoader = false;
            if (data.statusCode == 200) {
              this.snackbar.openSnackBar('Uploaded Successfully', '');
            }
          },
          (err: any) => {
            this.showLoader = false;
          }
        );
        this.http.post('v1/updateOdcComments',{shipmentId : this.odc_shipmentId, carrier_Comment : this.odcTextInput, SIN : this.odc_sin }, 1).subscribe(
          (data: any) => {
            this.showLoader = false;
            if (data.statusCode == 200) {
              this.snackbar.openSnackBar('Carrier comments added', '');
            }
          },
          (err: any) => {
            this.showLoader = false;
            this.formData = new FormData();
            if (err.error.statusCode == 401) {
              this.valid.logout();
            }
          }
        );
      this.odcTextInput = '';
      this.formData.delete('odc_attachment');
    } else this.snackbar.openSnackBar('Please Upload a File', '', 'err');
  }
  openMwgDialg(element) {
    this.mwgDialogRef = this.dialog.open(this.mwgRequest, {
      panelClass: 'icon-outside',
    });
    this.http.get('/v1/getMwgLoadedWeight?shipment=' + element._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.mwg.mwga = data.data.mwga.toFixed(2);
          this.mwg.doNumber = data.data.do_numbers.join(', ');
          this.mwg.vehicle_capacity = (data.data.vehicle_capacity).toFixed(2);
          this.mwg.loadedWeight = (data.data.weight).toFixed(2);
          this.mwg.shipper = data.data.shipper.parent_name;
          this.mwg.MWG = (data.data.vehicle_capacity).toFixed(2);
        }
        this.mwg.shipment = element._id;
      },
      (err: any) => {
        console.log(err.error.message);
      }
    );
    this.mwg.sin = element.sin;
    this.mwg.vehicle = element.vehicleNumber;
    this.mwg.material = element.material.map(m => m.name).join(", ");
    this.mwg.pickUp = element.from[0].location.name;
    this.mwg.drop = element.to[0].location.name;
    this.mwg.pickUpDate = element.scheduledDate;
    this.mwg.shipment = element._id;
    this.mwg.MWG = this.mwg.vehicle_capacity
  }

  calculationMWG() {
    this.mwg.mwga = Number(((this.mwg.MWG) - this.mwg.loadedWeight).toFixed(2));
  }
  addMwg() {

    const payload = {
      shipment: this.mwg.shipment,
      MWG: this.mwg.MWG
    };
    this.http.post('v1/addMwgRequest', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar('Mwg Request Added', '');
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
    this.mwgDialogRef.close();
  }

  updateFreightNew(element) {
    const payload = {
      _id: element._id,
    };
    this.http.post('carrier_invoice/flushFreight', payload, 1).subscribe((data: any) => {
      if (data && data.statusCode == 200) {
        this.snackbar.openSnackBar(this.translation.instant('Freight Rates Flushed'));
      }
    },
      (err) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      });
  }

  getShipmentDetails(row) {
    this.showLoader = true;
    // this.getPenaltyDetails();
    // this.getMaterials();
    this.http.get('shipment/one?shipmentId=' + row._id).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {

          this.shipmentDetails = data.data;
          this.showLoader = false;
          const dialogRef = this.dialog.open(EpodsPrevComponent, {
            data: this.shipmentDetails
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result && result.refreshInvoice) {
              if (result.tab) {
                this.openShipmentDetails(row, result.tab);
              }
            } else {
              this.shipmentDetails = {};
            }
          });
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );


  }
  getMaterials() {
    throw new Error('Method not implemented.');
  }



  // openPullFreightDialg(element) {
  //   this.SIN = element.sin;
  //   this.vehicleNo = element.vehicleNumber;
  //   this.shipment = element._id
  //   this.pickupPull = element.from[0].location.name;
  //   const payload = {
  //     shipmentId: element._id,
  //   }
  //   this.http.get('/v1/shipment/getCities', payload).subscribe(
  //     (data: any) => {
  //       if (data.statusCode == 200) {
  //         this.destination = data.data;
  //       }
  //     }, (err) => {
  //       this.snackbar.openSnackBar(err.error.message, '', 'err');
  //     });
  //   this.http.post('carrier_invoice/getCarrierInvoiceByInvoice', { shipmentIds: [element._id], skip: true }, 1).subscribe(
  //     (data: any) => {
  //       if (data.statusCode === 200) {
  //         const res = data.data;
  //         this.invoiceNumbers = res.invoices[0].invoices.map(i => i.commercial_invoices[0].num).join(", ");
  //         this.freightRate = res.invoices[0].invoices[0].commercial_invoices[0].others.final_freight_rate;
  //       }
  //     },
  //     (err: any) => {
  //       this.snackbar.openSnackBar(err.error.message, '', 'err');
  //     }
  //   );
  //   this.pullFreightRef = this.dialog.open(this.PullFreightDialg, {
  //     panelClass: 'icon-outside',
  //   });
  // }

  getpullFreight() {
    if (this.selectedDestination) {
      const payload = {
        destination: this.selectedDestination.toLowerCase(),
        shipment: this.shipment,
      }
      this.http.get('v1/freight_rate_route_code/get', payload, 1).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.pullFreightRef.close();
            this.snackbar.openSnackBar(`New Freight Rate is ${data.data}`);
            this.closedialog();
          }
        }, (err) => {
          this.closedialog();
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        });
    } else {
      this.snackbar.openSnackBar('Please select a delivery location', '', 'err');
    }
  }

  closedialog() {
    this.selectedDestination = '';
    this.freightRate = '';
  }
  openshiftShipmentsDialg(element) {
    this.shiftSin = element.sin;
    this.shiftVehicleNo = element.vehicleNumber;
    this.shiftDonumbers = element.do_numbers.join(', ');
    this.shiftShipmentId = element._id;
    this.getPlants();
    this.shiftShipmentRef = this.dialog.open(this.shiftshipmentsDialog, {
      panelClass: 'icon-outside',
    });
  }

  getPlants() {
    this.http.get('v1/getPlants').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          const result = data.data;
          this.shiftshippersArr = result;
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      });
  }

  shiftShipments() {
    const payload = {
      shipment: this.shiftShipmentId,
      shipper: this.selectedJsplPlantId,
    }
    this.http.post('/v1/shift_shipper', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar('Shipment shifted');
          this.shiftShipmentRef.close();
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      });
  }
  onSelectOption(shipper) {
    this.selectedJsplPlantId = shipper.value;
  }
  closeShiftdialog() {
    this.shiftDonumbers = '';
    this.shiftShipmentId = '';
    this.shiftVehicleNo = '';
    this.selectedJsplPlantId = '';
    this.selectedJsplPlantName = '';
    this.shiftShipmentRef.close();
  }
  selectStatus(){
    this.selectedStatus=this.selectedStatus;
  }


  closeInvoiceTypedialog (){
    this.invoiceDataSource = [];
    this.changeInvoiceTypeRef.close();
    this.invoiceType = [];
  }

  changeType(element, type) {
    const temp = {_id: element._id, type: type};
   this.invoiceType.push(temp);
  }
  changeCtPt() {
    if (this.invoiceType.length) {
      const payload = {
      shipment: this.changeInvoiceTypeShipmentId,
      invoices: this.invoiceType,
    }
    this.http.post('carrier_invoice/updateInvoiceType', payload, 1).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar('Invoice Type Updated');
            this.changeInvoiceTypeRef.close();
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        });
        
     }
     this.closeInvoiceTypedialog();
  }

  openMissedEventDialog(element) {
    this.missedEventShipmentId = element._id;
    this.missedEventDialogRef = this.dialog.open(this.missedEvent, {
      panelClass: 'icon-outside',
    });
  }

  addMissedEvents() {
    type Payload = {
      event: any;
      shipment: any;
      OD_number?: number;
    };
    const payload: Payload = {
      event: this.selectedMissedEvent,
      shipment: this.missedEventShipmentId,
    };
    this.misssedEventDoNumber ? payload.OD_number = this.misssedEventDoNumber : '';
    this.http.post('v1/utility/pullMissedEventsJSPL', payload).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackbar.openSnackBar('Missed Event Added');
          this.missedEventDialogRef.close();
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      });
      this.closeMissedEvent();
  }
  closeMissedEvent(){
    this.selectedMissedEvent = '';
    this.missedEvents = '';
    this.missedEventShipmentId = '';
    this.misssedEventDoNumber = '';
    this.missedEventDialogRef.close();
  }

}
